import React, { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import { useLanguage } from "../../StoreContext/LanguageContext";
import apiService from "../../config"; // Import the apiService from config.js

const AddFinalLandholdingList = ({ onBack, onSuccess, projectId, proposalId }) => {
  const { language, translations } = useLanguage();
  const [selectedLocationInfo, setSelectedLocationInfo] = useState(null);
  const [selectedDistrictName, setSelectedDistrictName] = useState("");
  const [selectedTalukaName, setSelectedTalukaName] = useState("");
  const [selectedVillageName, setSelectedVillageName] = useState("");
  const [editDistrict, setEditDistrict] = useState(false);
  const [editTaluka, setEditTaluka] = useState(false);
  const [editVillage, setEditVillage] = useState(false);
  const [landHoldingTypes, setLandHoldingTypes] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);

  const [currentProjectId, setCurrentProjectId] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const [isCheckingSurvey, setIsCheckingSurvey] = useState(false);
  const [surveyCheckTimeout, setSurveyCheckTimeout] = useState(null);

  // ADD THESE NEW STATE VARIABLES HERE:
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    title: '',
    message: '',
    type: 'success'
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmConfig, setConfirmConfig] = useState({
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    type: 'warning'
  });

  // ADD THESE HELPER FUNCTIONS HERE:
  const showAlert = (title, message, type = 'info') => {
    setAlertConfig({ title, message, type });
    setShowAlertModal(true);

    // Auto-hide after 5 seconds
    // setTimeout(() => setShowAlertModal(false), 5000);
  };

  const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
    setConfirmConfig({ title, message, onConfirm, onCancel, type });
    setShowConfirmModal(true);
  };

  const [formData, setFormData] = useState({
    project_id: currentProjectId || "",
    proposal_id: "",
    district_id: "",
    taluka_id: "",
    village_id: "",
    land_no: "",
    landholder_name: "",
    survey_no: "",
    aqr_area: "",
    area_unit_id: 2,
    survey_type: "घर क्रमांक.",
    irrigable_type: "",
    irrigable_area: "",
    non_irrigable_area: "",
    total_area: "",
    is_active: 1,
    north: "",
    east: "",
    west: "",
    south: "",
    land_holding_type: "",
    house_total_area: "",
    construction_area: "",
    affected_area: "",
    house_owner_type: "",
    latitude: "",
    longitude: ""
  });

  const [areaUnits, setAreaUnits] = useState([]);
  const [projects, setProjects] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});


  // Survey type options
  const surveyTypes = [
    { value: "घर क्रमांक.", label: "घर क्रमांक." },
  ];

  const isHouseNumber = formData.survey_type === "घर क्रमांक.";


  // Irrigable type options
  const irrigableTypes = [
    { value: "Canal", label: "Canal" },
    { value: "Well", label: "Well" },
    { value: "Tube Well", label: "Tube Well" },
    { value: "Tank", label: "Tank" },
    { value: "River", label: "River" },
    { value: "Other", label: "Other" },
  ];

  useEffect(() => {
    if (isHouseNumber) {
      setFormData(prev => ({
        ...prev,
        total_area: "",
        aqr_area: "",
        land_holding_type: "",
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        total_area: "",
        construction_area: "",
        aqr_area: "",
        land_holding_type: "",
      }));
    }
  }, [formData.survey_type]);


  // project id and proposal id
  useEffect(() => {
    const locationInfoStr = localStorage.getItem("selectedLocationInfo");
    console.log("===============9", locationInfoStr);
    if (locationInfoStr) {
      try {
        const locationInfo = JSON.parse(locationInfoStr);
        console.log("📥 Location Info from localStorage:", locationInfo);

        // Ensure we have the location data
        const districtValue = locationInfo.district || "";
        const talukaValue = locationInfo.taluka || "";
        const villageValue = locationInfo.village || "";

        console.log("Setting location values:", {
          district: districtValue,
          taluka: talukaValue,
          village: villageValue
        });

        // Set formData with all location values at once
        setFormData((prev) => {
          const newFormData = {
            ...prev,
            district_id: districtValue,
            taluka_id: talukaValue,
            village_id: villageValue,
            project_id: locationInfo.projectId || prev.project_id,
            proposal_id: locationInfo.proposalId || prev.proposal_id,
          };

          console.log("New formData after location loading:", newFormData);
          return newFormData;
        });

        // Set display names
        setSelectedDistrictName(districtValue);
        setSelectedTalukaName(talukaValue);
        setSelectedVillageName(villageValue);
        setSelectedLocationInfo(locationInfo);

      } catch (e) {
        console.error("Error parsing selectedLocationInfo", e);
      }
    }
  }, []);

  //useeffect for project_id and proposal_id 
  useEffect(() => {
    const getProjectId = () => {
      const userData = localStorage.getItem("userData"); console.log("===============2", userData);
      if (userData) {
        const user = JSON.parse(userData);

        // 🔥 Fix: use default_project if present
        if (user.default_project) {
          console.log("🎯 getProjectId → from userData.default_project:", user.default_project);
          return user.default_project;
        }

        // fallback to first in project_id list
        let projectId = user.data?.project_id || user.project_id;
        if (typeof projectId === "string" && projectId.includes(",")) {
          projectId = projectId.split(",")[0].trim();
        }
        console.log("🎯 getProjectId → fallback from userData.project_id:", projectId);
        if (projectId) return projectId;
      }

      console.log("🎯 getProjectId → fallback to prop or empty");
      return projectId || "";
    };

    const getProposalId = () => {
      const locationInfo = localStorage.getItem("selectedLocationInfo");
      console.log("===============3", locationInfo);
      if (locationInfo) {
        try {
          const parsed = JSON.parse(locationInfo);

          // Debug logs to see the structure
          console.log("🔍 selectedLocationInfo structure:", parsed);
          console.log("🔍 Looking for proposalId in:", Object.keys(parsed));

          // Try different possible keys
          const proposalId =
            parsed.proposalId || parsed.proposal_id || parsed.id || "";
          console.log("🔍 Found proposalId:", proposalId);

          return proposalId;
        } catch (e) {
          console.error("Error parsing selected location info:", e);
        }
      }
      return "";
    };

    const detectedProjectId = getProjectId();
    const detectedProposalId = getProposalId();
    // Add these debug logs
    console.log(
      "Raw currentProjectData:",
      localStorage.getItem("currentProjectData")
    );
    console.log(
      "Raw selectedLocationInfo:",
      localStorage.getItem("selectedLocationInfo")
    );
    console.log("Raw userData:", localStorage.getItem("userData"));

    setFormData((prev) => ({
      ...prev,
      project_id: detectedProjectId,
      proposal_id: detectedProposalId,
    }));

    console.log("✅ Loaded Project ID:", detectedProjectId);
    console.log("✅ Loaded Proposal ID:", detectedProposalId);
  }, []);

  useEffect(() => {
    // Get selected location info from localStorage
    const locationInfo = localStorage.getItem("selectedLocationInfo");
    console.log("===============4", locationInfo);
    if (locationInfo) {
      try {
        const parsedLocationInfo = JSON.parse(locationInfo);

        console.log("Parsed Location Info:", parsedLocationInfo);
        setSelectedLocationInfo(parsedLocationInfo);
        setSelectedDistrictName(parsedLocationInfo.district || "");
        setSelectedTalukaName(parsedLocationInfo.taluka || "");
        setSelectedVillageName(parsedLocationInfo.village || "");

        // Set the form data with the selected location values
        setFormData((prev) => ({
          ...prev,
          district_id: parsedLocationInfo.district || "",
          taluka_id: parsedLocationInfo.taluka || "",
          village_id: parsedLocationInfo.village || "",
        }));
        setSelectedDistrictName(parsedLocationInfo.district || "");
        setSelectedTalukaName(parsedLocationInfo.taluka || "");
        setSelectedVillageName(parsedLocationInfo.village || "");

        console.log("Setting form data with location info:", {
          district_id: parsedLocationInfo.district,
          taluka_id: parsedLocationInfo.taluka,
          village_id: parsedLocationInfo.village,
        });
      } catch (e) {
        console.error("Error parsing selected location info:", e);
      }
    }
  }, []);

  // Calculate total area when irrigable or non-irrigable area changes
  useEffect(() => {
    // Validate acquired area doesn't exceed total area
    const aqrAreaNum = parseFloat(formData.aqr_area) || 0;
    const totalAreaNum = parseFloat(formData.total_area) || 0;

    if (aqrAreaNum > 0 && totalAreaNum > 0 && aqrAreaNum > totalAreaNum) {
      setErrors((prev) => ({
        ...prev,
        aqr_area: "Acquired area cannot exceed total area",
      }));
    } else {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.aqr_area;
        return newErrors;
      });
    }
  }, [formData.aqr_area, formData.total_area]);

  // Calculate total area when irrigable or non-irrigable area changes
  useEffect(() => {
    // Validate acquired area doesn't exceed total area
    const aqrAreaNum1 = parseFloat(formData.irrigable_area) || 0;
    const nonAqrAreaNum1 = parseFloat(formData.non_irrigable_area) || 0;
    const totalIrrigable1 = aqrAreaNum1 + nonAqrAreaNum1;
    const totalAreaNum1 = parseFloat(formData.total_area) || 0;

    if (totalIrrigable1 > 0 && totalAreaNum1 > 0 && totalIrrigable1 > parseFloat(formData.total_area)) {
      setErrors((prev) => ({
        ...prev,
        total_area: "Cultivable area and Non-Cultiable area cannot exceed total area",
      }));
    } else {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.total_area;
        return newErrors;
      });
    }
  }, [formData.irrigable_area, formData.non_irrigable_area, formData.total_area]);

  // Fetch area units and set default to hectare
  useEffect(() => {
    const fetchAreaUnits = async () => {
      try {
        const res = await apiService.getAreaUnits();
        const units = res.data || [];
        setAreaUnits(units);

        // Set default to hectare-are if available
        const hectareUnit = units.find(
          (unit) =>
            (unit.unit_code || "").toLowerCase() === "hect-are" ||
            (unit.unit_name || unit.name || unit.label || "")
              .toLowerCase()
              .includes("hectare-are")
        );
        if (hectareUnit && !formData.area_unit_id) {
          setFormData((prev) => ({
            ...prev,
            area_unit_id: hectareUnit.area_unit_id,
          }));
        }
      } catch (err) {
        console.error("Failed to load area units:", err.message);
      }
    };

    fetchAreaUnits();
  }, []);

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by this browser");
      return;
    }

    setLocationLoading(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;

        setFormData((prev) => ({
          ...prev,
          latitude: latitude.toFixed(6),
          longitude: longitude.toFixed(6)
        }));

        setLocationLoading(false);
      },
      (error) => {
        console.error(error);
        alert("Unable to fetch location. Please allow location access.");
        setLocationLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };


  const checkAndPopulateSurveyData = async (surveyNo, surveyType, districtId, talukaId, villageId, projectId, proposalId) => {
    // Validate all required parameters are present
    if (!surveyNo || !surveyType || !districtId || !talukaId || !villageId || !projectId || !proposalId) {
      console.log("❌ Missing required parameters for survey check:", {
        surveyNo, surveyType, districtId, talukaId, villageId, projectId, proposalId
      });
      return;
    }

    try {
      setIsCheckingSurvey(true);
      console.log("🔍 Checking survey data for:", { surveyNo, surveyType, districtId, talukaId, villageId });

      // Call API to check if survey exists and get boundary data
      const response = await apiService.get("getLandHolding", {
        projectId: projectId,
        proposalId: proposalId,
        distNo: districtId,
        talukaNo: talukaId,
        villageNo: villageId,
        surveyType: surveyType,
        surveyNo: surveyNo
      });

      // Check if survey data exists
      if (response.data && response.data.length > 0) {
        const surveyData = response.data[0]; // Get first matching record
        console.log("✅ Found existing survey data:", surveyData);

        // Auto-populate boundary fields and land holding type
        setFormData((prev) => ({
          ...prev,
          north: surveyData.north || "",
          east: surveyData.east || "",
          west: surveyData.west || "",
          south: surveyData.south || "",
          land_holding_type: surveyData.land_holding_type || ""
        }));

        // Show success message to user
        showAlert(
          "Survey Found",
          "Boundary details and land holding type have been auto-filled from existing survey data.",
          "success"
        );
      } else {
        console.log("ℹ️ No existing survey data found for this combination");
      }
    } catch (error) {
      console.error("❌ Error checking survey data:", error);
      // Don't show error to user as this is background functionality
    } finally {
      setIsCheckingSurvey(false);
    }
  };

  useEffect(() => {
    const fetchLandHoldingTypes = async () => {
      try {
        const res = await apiService.getLandHoldingType();
        const types = res.data || [];
        setLandHoldingTypes(types);

        // Optional: auto-select first type if none is selected
        if (types.length > 0 && !formData.land_holding_type) {
          setFormData((prev) => ({
            ...prev,
            land_holding_type: types[0].land_holding_type, // Store name
          }));
        }
      } catch (err) {
        console.error("Failed to load land holding types:", err.message);
      }
    };

    fetchLandHoldingTypes();
  }, []);

  // Fetch initial data
  // Update the districts useEffect to get district name
  useEffect(() => {
    const fetchInitialData = async () => {
      if (formData.district_id) {
        // already set from locationInfo → skip fetch
        console.log("✅ District already selected:", formData.district_id);
        return;
      }

      try {
        setLoading(true);

        // Fetch districts
        const districtsRes = await apiService.getDistricts();
        const fetchedDistricts = districtsRes.data || [];
        setDistricts(fetchedDistricts);

        console.log("Selected Location Info:", selectedLocationInfo);

        // If we have selected location info, find and set the district name
        if (selectedLocationInfo && selectedLocationInfo.district) {
          const selectedDist = fetchedDistricts.find(
            (d) => d.dist_name == selectedLocationInfo.district
          );
          if (selectedDist) {
            setSelectedDistrictName(selectedDist.dist_name);
          }

          if (selectedDist) {
            const districtName = selectedDist.dist_name;
            setSelectedDistrictName(districtName);
          }
        }
      } catch (err) {
        console.error("Failed to load initial data:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [selectedLocationInfo]);

  // Update the talukas useEffect
  useEffect(() => {
    const fetchTalukas = async () => {
      if (formData.district_id) {
        // Don't reset if we have preselected location data
        const locationInfo = localStorage.getItem('selectedLocationInfo');
        console.log("===============5", locationInfo);
        let hasPreselectedData = false;

        if (locationInfo) {
          try {
            const parsed = JSON.parse(locationInfo);
            hasPreselectedData = !!(parsed.taluka && parsed.village);
          } catch (e) {
            console.error('Error checking preselected data:', e);
          }
        }

        try {
          setLoading(true);
          const res = await apiService.getTalukas(formData.district_id);
          const fetchedTalukas = res.data || [];
          setTalukas(fetchedTalukas);

          // Only auto-select or reset if we don't have preselected data
          if (!hasPreselectedData && selectedLocationInfo && selectedLocationInfo.talukaName) {
            const selectedTal = fetchedTalukas.find(
              (t) => t.taluka_name === selectedLocationInfo.talukaName
            );
            if (selectedTal) {
              setSelectedTalukaName(selectedTal.taluka_name);
            }
          }

          // DON'T reset if we have preselected data
          if (!hasPreselectedData && !selectedLocationInfo) {
            setFormData((prev) => ({
              ...prev,
              taluka_id: "",
              village_id: "",
            }));
            setVillages([]);
          }
        } catch (err) {
          console.error("Failed to load talukas:", err.message);
          setTalukas([]);
        } finally {
          setLoading(false);
        }
      } else {
        setTalukas([]);
        setVillages([]);
        // Only reset if no preselected data
        const locationInfo = localStorage.getItem('selectedLocationInfo');
        console.log("===============6", locationInfo);
        let hasPreselectedData = false;

        if (locationInfo) {
          try {
            const parsed = JSON.parse(locationInfo);
            hasPreselectedData = !!(parsed.taluka || parsed.village);
          } catch (e) {
            console.error('Error checking preselected data:', e);
          }
        }

        if (!hasPreselectedData) {
          setFormData((prev) => ({
            ...prev,
            taluka_id: "",
            village_id: "",
          }));
        }
      }
    };

    fetchTalukas();
  }, [formData.district_id]); // Remove selectedLocationInfo from dependencies

  // 4. Update the villages useEffect:
  useEffect(() => {
    const fetchVillages = async () => {
      if (formData.district_id && formData.taluka_id) {
        // Check for preselected data
        setVillages([]);
        const locationInfo = localStorage.getItem('selectedLocationInfo');
        console.log("===============7", locationInfo);
        let hasPreselectedVillage = false;

        if (locationInfo) {
          try {
            const parsed = JSON.parse(locationInfo);
            hasPreselectedVillage = !!parsed.village;
          } catch (e) {
            console.error('Error checking preselected data:', e);
          }
        }

        try {
          setLoading(true);
          const res = await apiService.getVillages(
            formData.district_id,
            formData.taluka_id
          );
          const fetchedVillages = res.data || [];
          setVillages(fetchedVillages);

          // Only auto-select if no preselected data
          if (!hasPreselectedVillage && selectedLocationInfo && selectedLocationInfo.villageName) {
            const selectedVill = fetchedVillages.find(
              (v) => v.village_name === selectedLocationInfo.villageName
            );
            if (selectedVill) {
              setSelectedVillageName(selectedVill.village_name);
            }
          }

          // Don't reset if we have preselected data
          if (!hasPreselectedVillage && !selectedLocationInfo) {
            setFormData((prev) => ({
              ...prev,
              village_id: "",
            }));
          }
        } catch (err) {
          console.error("Failed to load villages:", err.message);
          setVillages([]);
        } finally {
          setLoading(false);
        }
      } else {
        setVillages([]);
        // Only reset if no preselected data
        const locationInfo = localStorage.getItem('selectedLocationInfo');
        console.log("===============8", locationInfo);
        let hasPreselectedVillage = false;

        if (locationInfo) {
          try {
            const parsed = JSON.parse(locationInfo);
            hasPreselectedVillage = !!parsed.village;
          } catch (e) {
            console.error('Error checking preselected data:', e);
          }
        }

        if (!hasPreselectedVillage && !selectedLocationInfo) {
          setFormData((prev) => ({
            ...prev,
            village_id: "",
          }));
        }
      }
    };

    fetchVillages();
  }, [formData.district_id, formData.taluka_id]); // Remove selectedLocationInfo from dependencies

  const isPreselected =
    selectedLocationInfo &&
    selectedLocationInfo.district &&
    selectedLocationInfo.taluka &&
    selectedLocationInfo.village;

  useEffect(() => {
    // Cleanup timeout on component unmount
    return () => {
      if (surveyCheckTimeout) {
        clearTimeout(surveyCheckTimeout);
      }
    };
  }, [surveyCheckTimeout]);

  const safeTwoDecimals = (val) => {
    const num = parseFloat(val);
    if (isNaN(num)) return "";
    return parseFloat(num.toFixed(4));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    // Handle numeric fields consistently
    if (["total_area", "aqr_area", "irrigable_area", "non_irrigable_area"].includes(name)) {
      if (value === "") {
        newValue = ""; // allow clearing
      } else {
        // keep "0.x" but strip invalid leading zeros like "05"
        if (/^0\d+/.test(value)) {
          newValue = String(parseFloat(value));
        } else {
          newValue = value;
        }

        // restrict to max 2 decimal places
        if (/^\d+(\.\d{0,4})?$/.test(newValue) === false) {
          const [intPart, decPart] = newValue.split(".");
          newValue = intPart + "." + (decPart || "").slice(0, 2);
        }
      }
    }
    // 🔹 Handle survey type change and auto-set area unit
    if (name === "survey_type") {
      let areaUnitId = "";

      if (value === "सर्व्हे क्रमांक" || value === "गट क्रमांक") {
        areaUnitId = "18"; // Survey/Gat → 18
      } else if (value === "प्लॉट क्रमांक" | value === "घर क्रमांक.") {
        areaUnitId = "2"; // Plot/Ghar → 1
      }

      setFormData((prev) => ({
        ...prev,
        [name]: value,
        area_unit_id: areaUnitId,
      }));

      if (areaUnitId && errors.area_unit_id) {
        setErrors((prev) => ({
          ...prev,
          area_unit_id: "",
        }));
      }
      return; // 🚨 stop further processing for survey_type
    }

    // 🔹 Clamp logic: irrigable + non_irrigable must not exceed total
    if (name === "irrigable_area") {
      const maxAllowed = safeTwoDecimals(
        (parseFloat(formData.aqr_area) || 0) - (parseFloat(formData.non_irrigable_area) || 0)
      ); // 🔹 use acquired area instead of total
      if (parseFloat(newValue) > maxAllowed) {
        newValue = maxAllowed.toString();
        setErrors((prev) => ({
          ...prev,
          irrigable_area: `Cultivable area cannot exceed ${maxAllowed} ${formData.unit_name || ""}`,
        }));
      } else {
        setErrors((prev) => {
          const { irrigable_area, ...rest } = prev;
          return rest;
        });
      }
    }

    if (name === "non_irrigable_area") {
      const maxAllowed = safeTwoDecimals(
        (parseFloat(formData.aqr_area) || 0) - (parseFloat(formData.irrigable_area) || 0)
      );
      if (parseFloat(newValue) > maxAllowed) {
        newValue = maxAllowed.toString();

        setErrors((prev) => ({
          ...prev,
          non_irrigable_area: `Non-cultivable area cannot exceed ${maxAllowed} ${formData.unit_name || ""}`,
        }));
      } else {
        setErrors((prev) => {
          const { non_irrigable_area, ...rest } = prev;
          return rest;
        });
      }
    }

    if (name === "survey_no") {
      // Clear existing timeout to debounce API calls
      if (surveyCheckTimeout) {
        clearTimeout(surveyCheckTimeout);
      }

      // Update form data immediately for UI responsiveness
      setFormData((prev) => ({
        ...prev,
        [name]: newValue,
      }));

      // Set up debounced API call (wait 500ms after user stops typing)
      const newTimeout = setTimeout(() => {
        // Only check if survey number is not empty and all location data is available
        if (newValue.trim() && formData.survey_type && formData.district_id &&
          formData.taluka_id && formData.village_id && formData.project_id &&
          formData.proposal_id) {

          console.log("🔍 Triggering survey data check after debounce...");
          checkAndPopulateSurveyData(
            newValue.trim(),
            formData.survey_type,
            formData.district_id,
            formData.taluka_id,
            formData.village_id,
            formData.project_id,
            formData.proposal_id
          );
        }
      }, 500); // 500ms debounce delay

      setSurveyCheckTimeout(newTimeout);

      // Clear field error when user starts typing
      if (errors[name]) {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
      return; // Stop further processing for survey_no
    }

    // 🔹 Default update
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    // 🔹 Validation: irrigable_area + non_irrigable_area should not exceed total_area
    // ✅ Validation: acquired_area ≤ total_area, and irrigable+non_irrigable ≤ acquired_area
    setFormData((prev) => {
      const updatedData = { ...prev, [name]: newValue };

      const irrigable = parseFloat(updatedData.irrigable_area) || 0;
      const nonIrrigable = parseFloat(updatedData.non_irrigable_area) || 0;
      const total = parseFloat(updatedData.total_area) || 0;
      const acquired = parseFloat(updatedData.aqr_area) || 0;

      if (acquired > total) {
        showAlert(
          "Validation Error",
          "Acquired area cannot be more than Total Area",
          "warning"
        );
      }

      if (irrigable + nonIrrigable > acquired && acquired > 0) {
        showAlert(
          "Validation Error",
          "Cultivable + Non-Cultivable area cannot be more than Acquired Area",
          "warning"
        );
      }

      return updatedData;
    });


    // 🔹 Clear specific field error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Required field validation
    if (!formData.project_id) newErrors.project_id = "Project is required";
    if (!formData.district_id) newErrors.district_id = "District is required";
    if (!formData.taluka_id) newErrors.taluka_id = "Taluka is required";
    if (!formData.village_id) newErrors.village_id = "Village is required";
    if (!formData.survey_type) {
      newErrors.survey_type = "Please select a survey type (e.g., सर्व्हे क्रमांक, गट क्रमांक, प्लॉट क्रमांक, etc.)";
    }
    if (!formData.survey_no.trim())
      newErrors.survey_no = "Survey number is required";
    if (!formData.area_unit_id)
      newErrors.area_unit_id = "Area unit is required";

    if (!formData.latitude || !formData.longitude) {
      newErrors.location = "Please fetch location using Location button";
    }

    // Area validation
    // if (formData.aqr_area > formData.total_area) {
    //   newErrors.aqr_area = "Acquired area cannot exceed total area";
    // }

    // Area validation — always compare numeric values
    const aqrAreaNum = parseFloat(formData.aqr_area) || 0;
    const totalAreaNum = parseFloat(formData.total_area) || 0;

    if (aqrAreaNum > totalAreaNum) {
      newErrors.aqr_area = "Acquired area cannot exceed total area";
    } else {
      // ensure no stale error remains (newErrors is fresh so this line is optional,
      // but good for clarity if you reuse an error object)
      delete newErrors.aqr_area;
    }


    // irrigation validation
    const irrgable = parseFloat(formData.irrigable_area) || 0;
    const nonIrrgable = parseFloat(formData.non_irrigable_area) || 0;
    const totalIrrigable = irrgable + nonIrrgable;
    const totalArea = parseFloat(formData.total_area) || 0;

    if (totalIrrigable > totalArea) {
      newErrors.irrigable_area = "Cultivable + Non-Cultivable area cannot exceed total area";
    }


    if (!formData.north) newErrors.north = "North is required";
    if (!formData.east) newErrors.east = "East is required";
    if (!formData.south) newErrors.south = "South is required";
    if (!formData.west) newErrors.west = "Eest is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.project_id || !formData.proposal_id) {
      console.warn('❌ Missing project_id or proposal_id in formData:', formData);
      showAlert('Project ID and Proposal ID are required. Please check your selection.');
      return;
    }

    if (formData) {
      console.log("Form Data before submission:----------------------------------------", formData);
    }
    
    try {
      setIsSubmitting(true);

      // Validate required fields
      if (!formData.district_id || !formData.taluka_id || !formData.village_id) {
        showAlert('District, Taluka, and Village are required fields');
        return;
      }

      // Ensure we have the correct API field names in the payload
      const payload = {
        project_id: formData.project_id,
        proposal_id: formData.proposal_id,
        village_name: formData.village_id,        // "Akkalkuwa"
        surveyNo: formData.survey_no,
        aqrArea: parseFloat(formData.aqr_area) || 0,
        areaUnitId: formData.area_unit_id,
        landholderName: formData.landholder_name,
        surveyType: formData.survey_type,
        irrigableType: formData.irrigable_type,
        irrigableArea: (parseFloat(formData.irrigable_area) || 0).toString(),
        nonIrrigableArea: (parseFloat(formData.non_irrigable_area) || 0).toString(),
        totalArea: (parseFloat(formData.total_area) || 0).toString(),
        // construction_area:formData.construction_area ,
        north: formData.north,
        east: formData.east,
        west: formData.west,
        south: formData.south,
        isActive: formData.is_active,
        dist_name: formData.district_id,          // "Nandurbar"
        taluka_name: formData.taluka_id,          // "Akklakuva"
        land_holding_type: formData.land_holding_type, // now sends "Class-I" or "Class-II"
        latitude: formData.latitude,
        longitude: formData.longitude
      };

      if (formData.construction_area) {
        payload.construction_area = formData.construction_area
      }

      console.log("Final Payload being sent:", JSON.stringify(payload, null, 2));

      // Pass the payload data to the API method
      const result = await apiService.postAddLandHolding(payload);

      if (result.status === 200) {
        showAlert("Landholding data has been saved successfully!");
        console.log("Success:", result.data);

        // Reset form
        setFormData((prev) => ({
          ...prev,
          land_no: "",
          landholder_name: "",
          survey_no: "",
          aqr_area: "",
          survey_type: "घर क्रमांक.",
          irrigable_type: "",
          irrigable_area: "",
          non_irrigable_area: "",
          total_area: "",
          north: "",
          east: "",
          west: "",
          south: "",
          is_active: 1,
          land_holding_type: "",
          // ✅ Keep these as they are
          district_id: prev.district_id,
          taluka_id: prev.taluka_id,
          village_id: prev.village_id,
        }));

        // Call onSuccess callback to refresh parent data and hide form
        setTimeout(() => {
          if (typeof onSuccess === "function") {
            onSuccess();
          }
        }, 2000);
      } else if (result.status === 201) {
        setModalMessage(result.message);
        setModalOpen(true); // Open the warning modal
        setFormData((prev) => ({
          ...prev,
          land_no: "",
          landholder_name: "",
          survey_no: "",
          aqr_area: 0,
          // area_unit_id: "",
          survey_type: "घर क्रमांक.",
          irrigable_type: "",
          irrigable_area: 0,
          non_irrigable_area: 0,
          total_area: 0,
          north: "",
          east: "",
          west: "",
          south: "",
          is_active: 1,
          // ✅ Keep these as they are
          district_id: prev.district_id,
          taluka_id: prev.taluka_id,
          village_id: prev.village_id,
        }));
      }
      else {
        showAlert(
          `Error: ${result.data?.message || "Failed to save landholding data"}`
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showAlert("An error occurred while saving the data. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-300 shadow-lg w-full max-w-7xl mx-auto my-4 sm:my-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-900 to-blue-900 text-white px-4 sm:px-6 py-3 sm:py-4 rounded-t-lg">
        <div className="flex items-center justify-between">
          <h2 className="text-base sm:text-lg font-semibold flex items-center">
            <Plus className="h-4 w-4 sm:h-5 sm:w-5 mr-2" />
            <span className="hidden sm:inline">नवीन भूधारक समाविष्ट करा</span>
            <span className="sm:hidden">{translations[language]?.AddLandholding}</span>
          </h2>
          <button
            onClick={onBack}
            className="text-white hover:text-gray-200 transition-colors duration-200"
            title="Close Form"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Form Content */}
      <div className="p-4 sm:p-6">
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 sm:space-y-6">

            {/* Location Fields */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              {/* DISTRICT */}
              <div className="space-y-1 sm:space-y-2">
                <label className="block text-xs sm:text-sm font-medium text-gray-700">
                  {translations[language]?.district}<span className="text-red-500 ml-1">*</span>
                </label>
                {isPreselected && !editDistrict ? (
                  <div
                    onClick={() => setEditDistrict(true)}
                    className="w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md bg-blue-50 text-blue-800 shadow-sm cursor-pointer hover:bg-blue-100 font-medium"
                  >
                    {selectedDistrictName || "Please select first"}
                  </div>
                ) : (
                  <select
                    name="district_id"
                    value={formData.district_id}
                    onChange={handleChange}
                    className="w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                    required
                  >
                    {loading && districts.length === 0 ? (
                      <option>{translations[language]?.LoadingDistricts}</option>
                    ) : (
                      <>
                        <option value="" disabled>{translations[language]?.SelectDistrict}</option>
                        {districts.map((district) => (
                          <option
                            key={district.dist_name}
                            value={district.dist_name}
                          >
                            {district.dist_name}
                          </option>
                        ))}
                      </>
                    )}
                  </select>
                )}
              </div>

              {/* TALUKA */}
              <div className="space-y-1 sm:space-y-2">
                <label className="block text-xs sm:text-sm font-medium text-gray-700">
                  {translations[language]?.taluka}<span className="text-red-500 ml-1">*</span>
                </label>
                {isPreselected && !editTaluka ? (
                  <div>
                    <div onClick={() => setEditTaluka(true)} className="w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md bg-blue-50 text-blue-800 shadow-sm cursor-pointer hover:bg-blue-100 font-medium">
                      {selectedTalukaName || "Please select first"}
                    </div>
                    <input type="hidden" name="taluka_id" value={formData.taluka_id} />
                  </div>
                ) : (
                  <select
                    name="taluka_id"
                    value={formData.taluka_id}
                    onChange={handleChange}
                    className="w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                    required
                    disabled={!formData.district_id}
                  >
                    {loading && talukas.length === 0 ? (
                      <option>{translations[language]?.LoadingTalukas}</option>
                    ) : (
                      <>
                        <option value="" disabled>{translations[language]?.SelectTaluka}</option>
                        {talukas.map((taluka) => (
                          <option
                            key={taluka.taluka_name}
                            value={taluka.taluka_name}
                          >
                            {taluka.taluka_name}
                          </option>
                        ))}
                      </>
                    )}
                  </select>
                )}
              </div>

              {/* Village */}
              <div className="space-y-1 sm:space-y-2 sm:col-span-2 lg:col-span-1">
                <label className="block text-xs sm:text-sm font-medium text-gray-700">
                  {translations[language]?.village}<span className="text-red-500 ml-1">*</span>
                </label>
                {isPreselected && !editVillage ? (
                  <div>
                    <div onClick={() => setEditVillage(true)} className="w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md bg-blue-50 text-blue-800 shadow-sm cursor-pointer hover:bg-blue-100 font-medium">
                      {selectedVillageName || "Please select first"}
                    </div>
                    <input type="hidden" name="village_id" value={formData.village_id} />
                  </div>
                ) : (
                  <select
                    name="village_id"
                    value={formData.village_id}
                    onChange={handleChange}
                    className="w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                    required
                    disabled={!formData.district_id || !formData.taluka_id}
                  >
                    {loading && villages.length === 0 ? (
                      <option>{translations[language]?.LoadingVillages}</option>
                    ) : (
                      <>
                        <option value="" disabled>{translations[language]?.SelectVillage}</option>
                        {villages.map((village) => (
                          <option
                            key={village.village_name}
                            value={village.village_name}
                          >
                            {village.village_name}
                          </option>
                        ))}
                      </>
                    )}
                  </select>
                )}
              </div>
            </div>

            {/* Survey & Area Fields - 5 Columns */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
              {/* Survey Type */}
              <div className="space-y-1 sm:space-y-2">
                <label className="block text-xs sm:text-sm font-medium text-gray-700">
                  {translations[language]?.SurveyType}<span className="text-red-500 ml-1">*</span>
                </label>
                <select
                  name="survey_type"
                  value={formData.survey_type}
                  onChange={handleChange}
                  className="w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                  required
                >
                  <option value="" disabled >{translations[language]?.SelectSurveyType || "Select Survey Type"}</option>
                  {surveyTypes.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
                {errors.survey_type && (
                  <span className="text-xs text-red-600 mt-1 block">
                    {errors.survey_type}
                  </span>
                )}
              </div>
              {/* Survey No */}
              <div className="space-y-1 sm:space-y-2">
                <label className="block text-xs sm:text-sm font-medium text-gray-700">
                  {formData.survey_type || "Survey Number"}
                  <span className="text-red-500 ml-1">*</span>
                  {isCheckingSurvey && (
                    <span className="ml-2 text-xs text-blue-600">
                      <svg className="inline animate-spin h-3 w-3 mr-1" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Checking...
                    </span>
                  )}
                </label>
                <input
                  type="text"
                  name="survey_no"
                  value={formData.survey_no}
                  onChange={handleChange}
                  className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.survey_no
                    ? "border-red-400 bg-red-50"
                    : "border-gray-300"
                    } ${isCheckingSurvey ? "border-blue-300 bg-blue-50" : ""}`}
                  required
                  disabled={!formData.survey_type || isCheckingSurvey}
                />
                {errors.survey_no && (
                  <span className="text-xs text-red-600 mt-1 block">
                    {errors.survey_no}
                  </span>
                )}
              </div>

              {/* Area Unit */}
              <div className="space-y-1 sm:space-y-2">
                <label className="block text-xs sm:text-sm font-medium text-gray-700">
                  {translations[language]?.AreaUnit}<span className="text-red-500 ml-1">*</span>
                </label>
                <select
                  name="area_unit_id"
                  value={formData.area_unit_id}
                  onChange={handleChange}
                  className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.area_unit_id
                    ? "border-red-400 bg-red-50"
                    : "border-gray-300"
                    }`}
                  required
                >
                  <option value="" disabled >{translations[language]?.SelectAreaUnit}</option>
                  {areaUnits.map((unit) => (
                    <option key={unit.area_unit_id} value={unit.area_unit_id}>
                      {unit.unit_name}
                    </option>
                  ))}
                </select>
                {errors.area_unit_id && (
                  <span className="text-xs text-red-600 mt-1 block">
                    {errors.area_unit_id}
                  </span>
                )}
              </div>

              {/* Total Area */}
              {!isHouseNumber && (
                <>
                  <div className="space-y-1 sm:space-y-2">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      {translations[language].TotalArea}<span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      type="text"
                      name="total_area"
                      value={formData.total_area}
                      onChange={handleChange}
                      className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.total_area
                        ? "border-red-400 bg-red-50"
                        : "border-gray-300"
                        }`}
                      placeholder={translations[language].EnterTotalArea}
                      // step="0.01"
                      // min="0"
                      required
                      disabled={!formData.area_unit_id}
                    />
                    {errors.total_area && (
                      <span className="text-xs text-red-600 mt-1 block">
                        {errors.total_area}
                      </span>
                    )}
                    {!formData.area_unit_id && (
                      <span className="text-xs text-amber-600">{translations[language].PleaseSelectAreaUnitFirst}</span>
                    )}
                  </div>

                  {/* Acquired Area */}
                  <div className="space-y-1 sm:space-y-2">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      {translations[language].AcquiredArea}<span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      type="text"
                      name="aqr_area"
                      value={formData.aqr_area}
                      onChange={handleChange}
                      className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.aqr_area
                        ? "border-red-400 bg-red-50"
                        : "border-gray-300"
                        }`}
                      placeholder={translations[language].EnterAcquiredArea}
                      // step="0.01"
                      // min="0"
                      max={formData.total_area || undefined}
                      disabled={!formData.area_unit_id}
                    />
                    {errors.aqr_area && (
                      <span className="text-xs text-red-600 mt-1 block">
                        {errors.aqr_area}
                      </span>
                    )}
                    {!formData.area_unit_id && (
                      <span className="text-xs text-amber-600">{translations[language].PleaseSelectAreaUnitFirst}</span>
                    )}
                    {formData.total_area && parseFloat(formData.total_area) > 0 && (
                      <span className="text-xs text-gray-500">
                        {translations[language].Maximum}: {formData.total_area}
                      </span>
                    )}
                  </div>
                </>
              )}

              {isHouseNumber && (
                <>
                  {/* घराचे एकूण क्षेत्र */}
                  <div className="space-y-1 sm:space-y-2">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      घराचे एकूण क्षेत्र <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      type="text"
                      name="total_area"
                      value={formData.total_area}
                      required
                      onChange={handleChange}
                      className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.total_area
                        ? "border-red-400 bg-red-50"
                        : "border-gray-300"
                        }`}
                    />
                  </div>

                  {/* बांधकाम क्षेत्र */}
                  <div className="space-y-1 sm:space-y-2">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      बांधकाम क्षेत्र <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      type="text"
                      name="construction_area"
                      value={formData.construction_area}
                      required
                      onChange={handleChange}
                      className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.construction_area
                        ? "border-red-400 bg-red-50"
                        : "border-gray-300"
                        }`}
                    />
                  </div>

                  {/* संपादित क्षेत्र */}
                  <div className="space-y-1 sm:space-y-2 mt-4">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      संपादित क्षेत्र <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      type="text"
                      name="aqr_area"
                      value={formData.aqr_area}
                      required
                      onChange={handleChange}
                      className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.aqr_area
                        ? "border-red-400 bg-red-50"
                        : "border-gray-300"
                        }`}
                    />
                  </div>

                  <div className="space-y-1 sm:space-y-2 mt-4">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700">
                      घर मालकाचे नाव<span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      type="text"
                      name="landholder_name"
                      value={formData.landholder_name}
                      onChange={handleChange}
                      required
                      className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.landholder_name
                        ? "border-red-400 bg-red-50"
                        : "border-gray-300"
                        }`}
                      placeholder={translations[language].EnterName}
                    />
                    {errors.landholder_name && (
                      <span className="text-xs text-red-600 mt-1 block">
                        {errors.landholder_name}
                      </span>
                    )}
                    <span className="text-xs text-gray-500 mt-1 block">{translations[language].UseCommasToSeparateNames}</span>
                  </div>

                  <div className="space-y-1 sm:space-y-2">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700 mt-4">
                      {translations[language].SelectLandholdingType} <span className="text-red-500 ml-1">*</span>
                    </label>

                    <select
                      name="land_holding_type"
                      value={formData.land_holding_type || ""}
                      onChange={handleChange}
                      className="w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md
                    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                      required
                    >
                      <option value="" disabled>
                        {translations[language].SelectLandholdingType}
                      </option>
                      <option value="स्वताचे मालकीचे">स्वताचे मालकीचे</option>
                      <option value="अतिक्रमित">अतिक्रमित</option>
                      <option value="भाड्याचे">भाड्याचे</option>
                    </select>
                  </div>
                </>
              )}
            </div>

            {/* Landholder Name and Buttons */}
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3 sm:gap-4"> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
              {!isHouseNumber && (
                <>
                  {/* Landholder Name - takes 2 columns on large screens */}
                  <div className="space-y-1 sm:space-y-2">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                      {translations[language].landholderName}<span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      type="text"
                      name="landholder_name"
                      value={formData.landholder_name}
                      onChange={handleChange}
                      required
                      className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.landholder_name
                        ? "border-red-400 bg-red-50"
                        : "border-gray-300"
                        }`}
                      placeholder={translations[language].EnterName}
                    />
                    {errors.landholder_name && (
                      <span className="text-xs text-red-600 mt-1 block">
                        {errors.landholder_name}
                      </span>
                    )}
                    <span className="text-xs text-gray-500 mt-1 block">{translations[language].UseCommasToSeparateNames}</span>
                  </div>

                  {/* irrigable_area */}
                  <div className="space-y-1 sm:space-y-2">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                      {translations[language].IrrigableArea}
                    </label>
                    <input
                      type="text"
                      name="irrigable_area"
                      value={formData.irrigable_area}
                      onChange={handleChange}
                      placeholder={translations[language].EnterIrrigableeArea}
                      className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md 
                  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white 
                  ${errors.irrigable_area ? "border-red-500" : "border-gray-300"}`}
                    />
                    {errors.irrigable_area && (
                      <span className="text-xs text-red-600 mt-1 block">
                        {errors.irrigable_area}
                      </span>
                    )}
                  </div>

                  {/* non_irrigable_area */}
                  <div className="space-y-1 sm:space-y-2">
                    <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                      {translations[language].NonIrrigableArea}
                    </label>
                    <input
                      type="text"
                      name="non_irrigable_area"
                      value={formData.non_irrigable_area}
                      onChange={handleChange}
                      placeholder={translations[language].EnterNonIrrigableArea}
                      className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md 
                  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white 
                  ${errors.non_irrigable_area ? "border-red-500" : "border-gray-300"}`}
                    />
                    {errors.non_irrigable_area && (
                      <span className="text-xs text-red-600 mt-1 block">
                        {errors.non_irrigable_area}
                      </span>
                    )}
                  </div>
                </>
              )}

              {/* भूधारण पद्धती/ Class type */}
              {!isHouseNumber && (
                <div className="space-y-1 sm:space-y-2">
                  <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2" >
                    {translations[language].SelectLandholdingType}
                  </label>
                  <select
                    name="land_holding_type"
                    value={formData.land_holding_type}
                    onChange={handleChange}
                    className={`w-full px-2 sm:px-3 py-2 text-xs sm:text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white ${errors.landholder_name ? "border-red-400 bg-red-50" : "border-gray-300"
                      }`}
                  >
                    <option value="" disabled >{translations[language].SelectLandholdingType}</option>
                    {landHoldingTypes.map((type) => (
                      <option key={type.land_holding_type_id} value={type.land_holding_type}>
                        {type.land_holding_type}
                      </option>
                    ))}
                  </select>
                </div>
              )}


            </div>

            <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-6 items-end mt-4">
  {/* RIGHT: Action Buttons */}
  <div className="flex justify-end">
    <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
      <button
        type="button"
        onClick={onBack}
        disabled={isSubmitting}
        className="w-full sm:w-auto px-4 sm:px-6 py-2 text-xs sm:text-sm 
          bg-gray-100 border border-gray-300 rounded-md text-gray-700 
          hover:bg-gray-200 hover:border-gray-400 transition-colors 
          font-medium disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {translations[language].Cancel}
      </button>

      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full sm:w-auto px-6 sm:px-8 py-2 text-xs sm:text-sm 
          bg-blue-600 text-white rounded-md hover:bg-blue-700 
          transition-colors font-medium shadow-sm hover:shadow 
          disabled:opacity-50 disabled:cursor-not-allowed 
          flex items-center justify-center"
      >
        <Plus className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />

        {isSubmitting ? (
          <>
            <svg
              className="animate-spin h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2 text-white"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              />
            </svg>
            <span className="hidden sm:inline">
              {translations[language].Saving}
            </span>
            <span className="sm:hidden">
              {translations[language].Save}
            </span>
          </>
        ) : (
          <>
            <span className="hidden sm:inline">
              {translations[language].AddLandholdingList}
            </span>
            <span className="sm:hidden">
              {translations[language].Add}
            </span>
          </>
        )}
      </button>
    </div>
  </div>

</div>

          </div>
        </form>
      </div>

      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg shadow-lg max-w-md w-full">
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-lg font-bold text-yellow-800">⚠ {translations[language].Warning}</h2>
              <button onClick={() => setModalOpen(false)} className="text-yellow-700 text-xl hover:text-yellow-900">&times;</button>
            </div>
            <p className="text-black-700">{modalMessage}</p>
            <div className="mt-4 text-right">
              <button
                onClick={() => setModalOpen(false)}
                className="bg-yellow-400 hover:bg-yellow-500 text-white font-semibold px-4 py-2 rounded"
              >
                {translations[language].Okay}
              </button>
            </div>
          </div>
        </div>
      )}
      {showAlertModal && (
        <div className="fixed top-4 right-4 z-50">
          <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
            alertConfig.type === 'warning' ? 'border-yellow-500' :
              alertConfig.type === 'info' ? 'border-blue-500' :
                'border-green-500'
            }`}>
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                  alertConfig.type === 'warning' ? 'bg-yellow-100' :
                    alertConfig.type === 'info' ? 'bg-blue-100' :
                      'bg-green-100'
                  }`}>
                  <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                    alertConfig.type === 'warning' ? 'text-yellow-600' :
                      alertConfig.type === 'info' ? 'text-blue-600' :
                        'text-green-600'
                    }`}>
                    {alertConfig.type === 'error' ? '✕' :
                      alertConfig.type === 'warning' ? '⚠' :
                        alertConfig.type === 'info' ? 'ℹ' : '✓'}
                  </span>
                </div>
              </div>
              <div className="ml-3 flex-1">
                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
              </div>
              <button
                onClick={() => setShowAlertModal(false)}
                className="ml-4 text-gray-400 hover:text-gray-600"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Simple Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
            <div className="p-6">
              <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                  'bg-blue-100'
                }`}>
                {confirmConfig.type === 'danger' ? '⚠' :
                  confirmConfig.type === 'warning' ? '⚠' : '?'}
              </div>

              <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                {confirmConfig.title}
              </h3>

              <p className="text-gray-600 text-sm mb-6 text-center">
                {confirmConfig.message}
              </p>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onCancel) confirmConfig.onCancel();
                  }}
                  className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                  }}
                  className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                    confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                      'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {translations[language].Confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default AddFinalLandholdingList;  